<template>
  <drop-down>
    <div
      slot="header"
      :class="$style['header']"
    >
      <div
        v-if="menu.active.image"
        :class="$style['item-icon']"
      >
        <component :is="menu.active.image" />
      </div>
      <span :class="$style['item-active']">
        {{ menu.active.text }}
      </span>
    </div>
    <ul
      slot="content"
      :class="$style.content"
    >
      <VuePerfectScrollbar
        ref="perfectScollbar"
        :class="$style['scroll-area']"
        :settings="{}"
      >
        <li
          v-for="link in menu.links"
          :class="$style['list-item']"
          :key="link.name"
        >
          <router-link
            v-if="link.isUrl"
            :class="$style.link"
            :to="link.url"
          >
            <span
              v-if="link.image"
              :class="$style['item-icon']"
            >
              <component :is="link.image" />
            </span>
            <span :class="$style['item-active']">
              {{ link.text }}
            </span>
          </router-link>
          <a
            v-else
            :class="$style.link"
            @click="clickHandler(link)"
          >
            <span
              v-if="link.image"
              :class="$style['item-icon']"
            >
              <component :is="link.image" />
            </span>
            <span :class="$style['item-active']">
              {{ link.text }}
            </span>
          </a>
        </li>
      </VuePerfectScrollbar>
    </ul>
  </drop-down>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DropDown from "./ds-dropdown";

export default {
  name: "DsDropdownMenu",
  components: {
    DropDown,
    VuePerfectScrollbar
  },
  props: {
    menu: {
      type: Object,
      default: () => ({
        active: {},
        links: []
      })
    }
  },
  mounted() {
    this.$refs.perfectScollbar.update();
  },
  methods: {
    clickHandler(link) {
      this.$emit("selected", link);
    }
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";

$item-space: 10px;

.header {
  display: inline-block;
  flex: 1;
}
.item-icon {
  display: inline-block;
  vertical-align: middle;
  img {
    display: block;
  }
}
.item-active {
  vertical-align: bottom;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-item,
link {
  line-height: $font-regular-size;
}
.content {
  padding: $item-space / 2;
}
.list-item {
  // max-width: 200px;
  &:hover {
    background-color: $light-silver-color;
    border-radius: 5px;
  }
}
.link {
  padding: $item-space $item-space/2;
  padding-left: 2px;
  color: #000;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  span:nth-child(2) {
    margin-left: 5px;
  }
}
.scroll-area {
  margin: auto;
  max-height: 50vh;
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-dropdown-menu.vue